export default __webpack_public_path__ + "static/media/car-fixing-3.5b79daec.jpg";